import React from 'react';
import { Item } from '../item';
import classes from './list.scss';
export const List = ({
  list,
  giveawayColor,
  onRemoveClick
}) => {
  if (!list.length) {
    return /*#__PURE__*/React.createElement(Item, {
      onClick: onRemoveClick,
      item: null,
      giveawayColor: giveawayColor
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, list.map(item => /*#__PURE__*/React.createElement(Item, {
    onClick: onRemoveClick,
    item: item,
    key: item._id,
    giveawayColor: giveawayColor
  })));
};